// extracted by css-extract-rspack-plugin
export default {"StaticDiffPreview":"StaticUnifiedDiffPreview-module__StaticDiffPreview__MCGYc","HeaderContainer":"StaticUnifiedDiffPreview-module__HeaderContainer__L06tG"};